import type { TFinanceFilters } from '@/schemas/analytics-finance.schema'
export const financeKeys = { all: ['analytics-finance'] as const, data: (userId: string | undefined, filters: TFinanceFilters) => ['analytics-finance', userId, filters] as const }
